import "./style.scss";

import { Spinner } from "components/shared/Spinner";
import StyledButton from "components/shared/StyledButton";
import { useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { downloadStatementArchive } from "store/statementsStore";
import { useAppDispatch, useAppSelector } from "store/store";

function useQuery() {
    const { search } = useLocation();

    return useMemo(() => new URLSearchParams(search), [search]);
}

function DownloadStatementArchive() {
    const query = useQuery();
    const dispatch = useAppDispatch();
    const [t] = useTranslation();
    const navigate = useNavigate();
    const downloadStatus = useAppSelector((state) => state.statements.downloadStatus);

    useEffect(() => {
        (async () => {
            dispatch(downloadStatementArchive({ query: query.get("fileKey") }));
        })();
    }, []);

    return (
        <div className="download-page-container">
            <span className="download-page-text">
                {downloadStatus === "pending" ? t("Download.Pending") : t("Download.Successful")}
            </span>
            {downloadStatus === "pending" && <Spinner />}
            {downloadStatus === "succeeded" && (
                <StyledButton buttonType="primary" onClick={() => navigate("/management")}>
                    {t("Download.Button")}
                </StyledButton>
            )}
        </div>
    );
}

export default DownloadStatementArchive;
